// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/Images/bg-left.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/Images/bg-right.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#footer{
    text-align: center;
}
.material-symbols-outlined {
    color: white;
    font-size: 100px;
    width: 150px;
    height: 150px;
    background: linear-gradient(#4a639a, #90aae2);
    text-align: center;
    line-height: 150px;
    border-radius: 50%;
    font-weight: 200;
    margin: 0px auto;
    display: block;
}
main {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    /* height: 90vh; */
    background-position: left top, right bottom;
    background-repeat: no-repeat, no-repeat;
    padding: 20px 0px;
    font-size: 14px;
}
.container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}

.critical-Illness, .health-Insurance {
    width: 120px;
    height: 120px;
    margin: 20px auto;
    background: linear-gradient(#4a639a, #90aae2);
    color: #fff;
    font-size: 24px;
    text-align: center;
    line-height: 70px;
    border-radius: 50%;
}
.policyNames{
    color:#000;
}
.critical-Illness a {
    display: block;
    margin: 0px auto;
    text-align: center;
    line-height: 120px;
}
.critical-Illness a img {
    width:60px;
}
*, ::after, ::before {
    box-sizing: border-box;
}
user agent stylesheet
img {
    overflow-clip-margin: content-box;
    overflow: clip;
}
a:hover {
    color: #0056b3;
    text-decoration: underline;
}
a {
    color: #007bff;
    text-decoration: none;
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
}

a:-webkit-any-link {
    color: -webkit-link;
    cursor: pointer;
}
.personal-Accident:hover, .critical-Illness:hover, .health-Insurance:hover {
    background: linear-gradient(#25335b, #425c96);
    cursor: pointer;
    transition: background-color 2s ease-out;
}
.OurParterList{
    border-top:1px solid #e7e7e7;
}

.critical-Illness a h4{ 
    color: #25335b;
    text-decoration: none;
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
}
.main_text:hover{
    text-decoration: underline;
}
.our-partner-section {
    padding: 30px 0px;
}
.carousel-item {
    position: relative;
    display: none;
    float: left;
    width: 100%;
    margin-right: -100%;
    backface-visibility: hidden;
    transition: transform .6s ease-in-out;
}
.critical-Illness a:hover {
    color: #0056b3;
    text-decoration: underline;
}
#footer {
    background-color: #CBCBD4 !important;
    color: #252525;
}
.ourCopyright{
    background-color: #25335b;
    padding:10px 0px 0px 0px;
    font-size: 12px;
    color:#fff;
}`, "",{"version":3,"sources":["webpack://./src/SidebarComponent/MainPage.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,6CAA6C;IAC7C,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,kGAA6E;IAC7E,kBAAkB;IAClB,2CAA2C;IAC3C,uCAAuC;IACvC,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,6CAA6C;IAC7C,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,UAAU;AACd;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,UAAU;AACd;AACA;IACI,sBAAsB;AAC1B;AACA;;IAEI,iCAAiC;IACjC,cAAc;AAClB;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,6BAA6B;IAC7B,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,6CAA6C;IAC7C,eAAe;IACf,wCAAwC;AAC5C;AACA;IACI,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,6BAA6B;IAC7B,qCAAqC;AACzC;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,2BAA2B;IAC3B,qCAAqC;AACzC;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,oCAAoC;IACpC,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,eAAe;IACf,UAAU;AACd","sourcesContent":["\r\n#footer{\r\n    text-align: center;\r\n}\r\n.material-symbols-outlined {\r\n    color: white;\r\n    font-size: 100px;\r\n    width: 150px;\r\n    height: 150px;\r\n    background: linear-gradient(#4a639a, #90aae2);\r\n    text-align: center;\r\n    line-height: 150px;\r\n    border-radius: 50%;\r\n    font-weight: 200;\r\n    margin: 0px auto;\r\n    display: block;\r\n}\r\nmain {\r\n    background-image: url(/src/Images/bg-left.png), url(/src/Images/bg-right.png);\r\n    /* height: 90vh; */\r\n    background-position: left top, right bottom;\r\n    background-repeat: no-repeat, no-repeat;\r\n    padding: 20px 0px;\r\n    font-size: 14px;\r\n}\r\n.container {\r\n    width: 100%;\r\n    padding-right: 15px;\r\n    padding-left: 15px;\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n}\r\n\r\n.critical-Illness, .health-Insurance {\r\n    width: 120px;\r\n    height: 120px;\r\n    margin: 20px auto;\r\n    background: linear-gradient(#4a639a, #90aae2);\r\n    color: #fff;\r\n    font-size: 24px;\r\n    text-align: center;\r\n    line-height: 70px;\r\n    border-radius: 50%;\r\n}\r\n.policyNames{\r\n    color:#000;\r\n}\r\n.critical-Illness a {\r\n    display: block;\r\n    margin: 0px auto;\r\n    text-align: center;\r\n    line-height: 120px;\r\n}\r\n.critical-Illness a img {\r\n    width:60px;\r\n}\r\n*, ::after, ::before {\r\n    box-sizing: border-box;\r\n}\r\nuser agent stylesheet\r\nimg {\r\n    overflow-clip-margin: content-box;\r\n    overflow: clip;\r\n}\r\na:hover {\r\n    color: #0056b3;\r\n    text-decoration: underline;\r\n}\r\na {\r\n    color: #007bff;\r\n    text-decoration: none;\r\n    background-color: transparent;\r\n    -webkit-text-decoration-skip: objects;\r\n}\r\n\r\na:-webkit-any-link {\r\n    color: -webkit-link;\r\n    cursor: pointer;\r\n}\r\n.personal-Accident:hover, .critical-Illness:hover, .health-Insurance:hover {\r\n    background: linear-gradient(#25335b, #425c96);\r\n    cursor: pointer;\r\n    transition: background-color 2s ease-out;\r\n}\r\n.OurParterList{\r\n    border-top:1px solid #e7e7e7;\r\n}\r\n\r\n.critical-Illness a h4{ \r\n    color: #25335b;\r\n    text-decoration: none;\r\n    background-color: transparent;\r\n    -webkit-text-decoration-skip: objects;\r\n}\r\n.main_text:hover{\r\n    text-decoration: underline;\r\n}\r\n.our-partner-section {\r\n    padding: 30px 0px;\r\n}\r\n.carousel-item {\r\n    position: relative;\r\n    display: none;\r\n    float: left;\r\n    width: 100%;\r\n    margin-right: -100%;\r\n    backface-visibility: hidden;\r\n    transition: transform .6s ease-in-out;\r\n}\r\n.critical-Illness a:hover {\r\n    color: #0056b3;\r\n    text-decoration: underline;\r\n}\r\n#footer {\r\n    background-color: #CBCBD4 !important;\r\n    color: #252525;\r\n}\r\n.ourCopyright{\r\n    background-color: #25335b;\r\n    padding:10px 0px 0px 0px;\r\n    font-size: 12px;\r\n    color:#fff;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
